import React from "react";

interface TabHeaderProps {
  icon: React.ElementType;
  title: string;
  subtitle?: string;
  action?: React.ReactNode;
}

export const TabHeader: React.FC<TabHeaderProps> = ({ icon: Icon, title, subtitle, action }) => (
  <div className="participant-card-header">
    <div className="participant-card-heading">
      <div className="participant-card-icon">
        <Icon className="h-4 w-4 text-[var(--azure-primary)]" />
      </div>
      <div className="leading-tight">
        <div className="participant-card-title">{title}</div>
        {subtitle && <div className="participant-card-subtitle">{subtitle}</div>}
      </div>
    </div>
    {action && <div className="flex items-start gap-2">{action}</div>}
  </div>
);
